import React from 'react'
import styled from 'styled-components'

interface LogoProps {
  logo?: string
}

const StyledLogo = styled.img`
  display: block;
  max-width: ${({ theme }) => theme.space.s160};
  max-height: ${({ theme }) => theme.space.s160};
  margin: ${({ theme }) => theme.space.s16} auto;

  ${({ theme }) => theme.mediaQuery.phone} {
    max-width: ${({ theme }) => theme.space.s128};
    max-height: ${({ theme }) => theme.space.s128};
    margin: ${({ theme }) => theme.space.s8} auto;
  }
`

export default function Logo({ logo }: LogoProps) {
  if (logo) {
    return <StyledLogo src={logo} alt="" />
  }
  return null
}
